import { BlogSection } from '@/types/blog';

export const bpmPrinzip: BlogSection = {
  id: 'bpm-prinzip',
  title: 'Dein Ruhepuls im Ohr: Das 60–120 BPM-Prinzip',
  content: `
    <p>
      Musikstücke mit 60 bis 120 Schlägen pro Minute ahmen deinen Ruhepuls nach. Instrumentaltracks in diesem Tempo entlasten dein Sprachzentrum, weil es sich nicht um Textverarbeitung kümmern muss. So bleibt mehr Kapazität für tiefes Nachdenken und fundierte Entscheidungen.
    </p>
  `
};
